<template>
  <!-- Masthead -->
  <header
    ref="header"
    :style="backgroundImage ? `background-image: url(${$base_api}/${backgroundImage}) !important;` : `background-image: unset !important`"
    class="masthead"
  >
    <div class="bg-img">
      <div class="container d-flex justify-content-between flex-column">
        <div class="row">
          <template v-if="activeOption === 'borrow'">
            <div
              ref="payDayForm"
              class="col-md-12 test-bg"
            >
              <div class="mb-4 d-block d-md-none">
                <div class="row">
                  <div
                    class="block-btn-borrow mb-2"
                    style="width: 100%"
                  >
                    <a
                      :class="borrowInvestModel === 'borrow' ? 'btn-active' : ''"
                      class="btn-borrow-invest black borrow-invest-item borrow-item"
                      @click="onClickBorrowInvest('borrow')"
                    >
                      {{ $t('label.borrow').toUpperCase() }}
                    </a>
                  </div>
                  <div
                    v-show="borrowInvestModel === 'borrow'"
                    class="col-sm-12"
                  >
                    <div class="sub-nav-content sub-navbar-content">
                      <div class="sub-nav-panel">
                        <ul class="nav navbar-nav">
                          <li class="sub-nav-item sub-nav-item  has-border-b">
                            <router-link
                              :to="{name: 'home'}"
                              class="sub-nav-penal-item"
                            >
                              <span class="sub-nav-panel-title bold">{{ $t('label.payDayLoan') }}</span>
                              <i class="fa fa-chevron-right nav-chevron-right" />
                              <span class="sub-nav-panel-desc">{{ $t('borrow.string.shortTerm') }}</span>
                            </router-link>
                          </li>
                          <li class="sub-nav-item sub-nav-item has-border-b">
                            <router-link
                              :to="{name: 'personal_loans'}"
                              class="sub-nav-penal-item"
                            >
                              <span class="sub-nav-panel-title bold">{{ $t('label.personalLoan') }}</span>
                              <i class="fa fa-chevron-right nav-chevron-right" />
                              <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
                            </router-link>
                          </li>
                          <li class="sub-nav-item sub-nav-item has-border-b">
                            <router-link
                              :to="{name: 'pawn_service'}"
                              class="sub-nav-penal-item"
                            >
                              <span class="sub-nav-panel-title bold">{{ $t('label.pawn') }}</span>
                              <i class="fa fa-chevron-right nav-chevron-right" />
                              <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
                            </router-link>
                          </li>
                          <li class="sub-nav-item sub-nav-item">
                            <router-link
                              :to="{name: 'purchasing_service'}"
                              class="sub-nav-penal-item"
                            >
                              <span class="sub-nav-panel-title bold">{{ $t('label.purchasing') }}</span>
                              <i class="fa fa-chevron-right nav-chevron-right" />
                              <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showForm === 'payday_loan'">
                <template>
                  <div ref="payDayForm">
                    <div class="row">
                      <div class="col-md-7 no-padding">
                        <payday-calculator
                          ref="payday"
                          :amount-duration="daySliderModel"
                          :amount-slider="amountSliderModel"
                          :interest-rates="interestRates"
                          :loan-model="paydayLoan"
                          :warning-amount="paydayWarning"
                        />
                      </div>
                      <div class="col-md-5 d-flex justify-content-center no-padding">
                        <div class="form-input-header">
                          <form-input-header
                            :apply-now="applyNow"
                            :is-loan-pending="isLoanPending"
                            :logged="isLogged"
                            :request-new-loan="requestNewLoan"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div v-else-if="showForm === 'personal_loan'">
                <template>
                  <div class="row">
                    <div class="col-md-7 no-padding">
                      <template>
                        <div class="form-borrow">
                          <div class="row">
                            <div class="col-md-12 text-center">
                              <p
                                class="label-title-loan display-amount-container"
                                style="font-size: 32px; color: var(--primary)"
                              >
                                <img
                                  alt=""
                                  src="img/icons/statement_black.svg"
                                  style="width: 45px"
                                > Personal <span
                                  style="color: var(--secondary)"
                                >Loans</span>
                              </p>
                            </div>
                            <div class="col-md-12 text-center display-amount-container mt-md-5">
                              {{ $t('label.youNeed', {count: amountPersonalSliderModel}) }}
                            </div>
                            <div class="col-md-12 text-center">
                              <slider
                                v-model="amountPersonalSliderModel"
                                :slider-interval="personalLoan.amount.interval"
                                :slider-max="personalLoan.amount.max"
                                :slider-min="personalLoan.amount.min"
                                :slider-warn="personalLoan.amount.warn"
                                label="label.var.usd"
                                @onWarn="(value) => {personalWarning = value}"
                              />
                            </div>
                            <div class="col-md-12 warning-container">
                              <div :class="`text-center ${personalWarning ? 'show' : ''}`">
                                {{ $t('warning.onlyForSecondBorrower') }}
                              </div>
                            </div>
                            <div class="col-md-12 text-center display-amount-container">
                              {{ $t('label.youBorrowForMonth', {count: monthSliderModel}) }}
                            </div>
                            <div class="col-md-12 text-center">
                              <slider
                                v-model="monthSliderModel"
                                :slider-interval="personalLoan.duration.interval"
                                :slider-max="personalLoan.duration.max"
                                :slider-min="personalLoan.duration.min"
                                :slider-warn="personalLoan.duration.warn"
                                label="label.var.month"
                              />
                              <!--$t('label.var.month')-->
                            </div>
                            <div class="col-md-12 text-center payment-container">
                              <div class="row">
                                <div class="col-md-12 payment-label">
                                  {{ $t('label.monthlyPayment') }}
                                </div>
                                <div class="col-md-12 payment-amount">
                                  USD {{ calculatePersonalLoan.toFixed(2) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="col-md-5 d-flex justify-content-center no-padding">
                      <div class="form-input-header">
                        <form-input-header
                          :apply-now="applyNow"
                          :is-loan-pending="isLoanPending"
                          :logged="isLogged"
                          :request-new-loan="requestNewLoan"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div v-else-if="showForm === 'pawn'">
                <template>
                  <div class="row">
                    <div class="col-md-7 no-padding">
                      <template>
                        <div class="form-borrow">
                          <div class="row">
                            <div class="col-md-12 text-center">
                              <p
                                class="label-title-loan display-amount-container"
                                style="font-size: 32px; color: var(--primary)"
                              >
                                <img
                                  alt=""
                                  src="img/icons/statement_black.svg"
                                  style="width: 45px"
                                > Pawn
                                <span style="color: var(--secondary)">Loan</span>
                              </p>
                            </div>
                            <div class="col-md-12 text-center display-amount-container mt-md-5">
                              {{ $t('label.youNeed', {count: amountPawnSliderModel}) }}
                            </div>
                            <div class="col-md-12 text-center">
                              <slider
                                v-model="amountPawnSliderModel"
                                :slider-interval="pawn.amount.interval"
                                :slider-max="pawn.amount.max"
                                :slider-min="pawn.amount.min"
                                :slider-warn="pawn.amount.warn"
                                label="label.var.usd"
                                @onWarn="(value) => {pawnWarning = value}"
                              />
                            </div>
                            <div class="col-md-12 warning-container">
                              <div :class="`text-center ${pawnWarning ? 'show' : ''}`">
                                {{ $t('warning.onlyForSecondBorrower') }}
                              </div>
                            </div>
                            <div class="col-md-12 text-center display-amount-container">
                              {{ $t('label.youBorrowForMonth', {count: monthPawnSliderModel}) }}
                            </div>
                            <div class="col-md-12 text-center">
                              <slider
                                v-model="monthPawnSliderModel"
                                :slider-interval="pawn.duration.interval"
                                :slider-max="pawn.duration.max"
                                :slider-min="pawn.duration.min"
                                :slider-warn="pawn.duration.warn"
                                label="label.var.month"
                              />
                              <!--$t('label.var.month')-->
                            </div>
                            <div class="col-md-12 text-center payment-container">
                              <div class="row">
                                <div class="col-md-12 payment-label">
                                  {{ $t('label.monthlyPayment') }}
                                </div>
                                <div class="col-md-12 payment-amount">
                                  USD {{ calculatePawn.toFixed(2) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="col-md-5 d-flex justify-content-center no-padding">
                      <div class="form-input-header">
                        <form-input-header
                          :apply-now="applyNow"
                          :is-loan-pending="isLoanPending"
                          :logged="isLogged"
                          :request-new-loan="requestNewLoan"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div v-else-if="showForm === 'purchasing'">
                <template>
                  <div class="row">
                    <div class="col-md-7 no-padding">
                      <template>
                        <div class="form-borrow">
                          <div class="row">
                            <div class="col-md-12 text-center">
                              <p
                                class="label-title-loan display-amount-container"
                                style="font-size: 32px; color: var(--primary)"
                              >
                                <img
                                  alt=""
                                  src="img/icons/statement_black.svg"
                                  style="width: 45px"
                                > Installment
                                <span style="color: var(--secondary)">Loan</span>
                              </p>
                            </div>
                            <div class="col-md-12 text-center display-amount-container mt-md-5">
                              {{ $t('label.youNeed', {count: amountPurchasingSliderModel}) }}
                            </div>
                            <div class="col-md-12 text-center">
                              <slider
                                v-model="amountPurchasingSliderModel"
                                :slider-interval="purchasing.amount.interval"
                                :slider-max="purchasing.amount.max"
                                :slider-min="purchasing.amount.min"
                                :slider-warn="purchasing.amount.warn"
                                label="label.var.usd"
                                @onWarn="(value) => {purchasingWarning = value}"
                              />
                            </div>
                            <div class="col-md-12 warning-container">
                              <div :class="`text-center ${purchasingWarning ? 'show' : ''}`">
                                {{ $t('warning.onlyForSecondBorrower') }}
                              </div>
                            </div>
                            <div class="col-md-12 text-center display-amount-container">
                              {{ $t('label.youBorrowForMonth', {count: monthPurchasingSliderModel}) }}
                            </div>
                            <div class="col-md-12 text-center">
                              <slider
                                v-model="monthPurchasingSliderModel"
                                :slider-interval="purchasing.duration.interval"
                                :slider-max="purchasing.duration.max"
                                :slider-min="purchasing.duration.min"
                                :slider-warn="purchasing.duration.warn"
                                label="label.var.month"
                              />
                            </div>
                            <div class="col-md-12 text-center payment-container">
                              <div class="row">
                                <div class="col-md-12 payment-label">
                                  {{ $t('label.monthlyPayment') }}
                                </div>
                                <div class="col-md-12 payment-amount">
                                  USD {{ calculatePurchasing.toFixed(2) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="col-md-5 d-flex justify-content-center no-padding">
                      <div class="form-input-header">
                        <form-input-header
                          :apply-now="applyNow"
                          :is-loan-pending="isLoanPending"
                          :logged="isLogged"
                          :request-new-loan="requestNewLoan"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Slider from '../components/Slider'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { dataOptions } from '@/views/form/dataOptions'
import PaydayCalculator from './components/PaydayCalculator'
import FormInputHeader from './components/FormInputHeader'

export default {
  name: 'CashHeroHeader',
  directives: { mask },
  components: { FormInputHeader, PaydayCalculator, Slider },
  watch: {
    '$route.name': function () {
      this.checkRoute()
    },
    '$i18n.locale': {
      handler: function (val, oldVal) {
        this.validations = null
      }
    },
    isLoanPending (newLogged, oldLogged) {
      console.log(newLogged)
    }
  },
  data () {
    return {
      isLogged: this.checkIfIsLogged(),
      backgroundImage: '',
      // orveral
      activeOption: 'borrow',
      showForm: 'personal_loan',
      masthead: null,
      scrolling: false,
      formHeight: 500,
      borrowInvestModel: 'none',
      baseUrl: process.env.VUE_APP_BASE_URL,
      validations: null,
      messageError: null,

      // model for payday loan
      paydayLoan: dataOptions.paydayLoan,
      amountSliderModel: 50,
      daySliderModel: 5,
      interestRates: [],
      paydayWarning: false,

      // model for personal loan
      personalLoan: dataOptions.personalLoan,
      amountPersonalSliderModel: 200,
      monthSliderModel: 1,
      interestRatesPersonalLoan: [],
      personalWarning: false,

      // model for purchasing
      purchasing: dataOptions.purchasing,
      amountPurchasingSliderModel: 200,
      monthPurchasingSliderModel: 1,
      interestRatesPurchasing: [],
      purchasingWarning: false,

      // model for pawn
      pawn: dataOptions.pawn,
      amountPawnSliderModel: 200,
      monthPawnSliderModel: 1,
      interestRatesPawn: [],
      pawnWarning: false
    }
  },
  computed: Object.assign(mapState({
    data: state => state.borrow
  }), {
    // calculate rate for personal loan
    interestRatePersonalLoan () {
      if (this.interestRatesPersonalLoan && this.interestRatesPersonalLoan.length > 0) {
        const rate = this.interestRatesPersonalLoan
        const tempResult = rate.filter((item) => {
          const satisfiedAmount = this.amountPersonalSliderModel >= item.start_amount && this.amountPersonalSliderModel <= item.end_amount
          const satifiedMonth = this.monthSliderModel >= item.start && this.monthSliderModel <= item.end
          const defaultMonth = item.start === 0 && item.end === 0
          return satisfiedAmount && (satifiedMonth || defaultMonth)
        })
        if (tempResult.length === 0) {
          const half = (this.personalLoan.amount.min + this.personalLoan.amount.max) / 2
          if (this.amountPersonalSliderModel > half) {
            return 8
          }
          return 15
        } else if (tempResult.length === 1) {
          return parseFloat(tempResult[0].percentage)
        } else {
          const res = tempResult.filter((item) => {
            return !(item.start === 0 && item.end === 0)
          })[0]
          return parseFloat(res.percentage)
        }
      }
    },
    calculatePersonalLoan () {
      const unRoundedMonthlyPayment = this.pmt(this.interestRatePersonalLoan, this.monthSliderModel, this.amountPersonalSliderModel)
      return Math.ceil(unRoundedMonthlyPayment)
    },

    // calculate rate for purchasing service
    interestRatePurchasing () {
      if (this.interestRatesPurchasing && this.interestRatesPurchasing.length > 0) {
        const rate = this.interestRatesPurchasing
        const tempResult = rate.filter((item) => {
          const satisfiedAmount = this.amountPurchasingSliderModel >= item.start_amount && this.amountPurchasingSliderModel <= item.end_amount
          const satifiedMonth = this.monthPurchasingSliderModel >= item.start && this.monthPurchasingSliderModel <= item.end
          const defaultMonth = item.start === 0 && item.end === 0
          return satisfiedAmount && (satifiedMonth || defaultMonth)
        })
        if (tempResult.length === 0) {
          const half = (this.purchasing.amount.min + this.purchasing.amount.max) / 2
          if (this.amountPurchasingSliderModel > half) {
            return 8
          }
          return 15
        } else if (tempResult.length === 1) {
          return parseFloat(tempResult[0].percentage)
        } else {
          const res = tempResult.filter((item) => {
            return !(item.start === 0 && item.end === 0)
          })[0]
          return parseFloat(res.percentage)
        }
      }
    },
    calculatePurchasing () {
      const unRoundedMonthlyPayment = this.pmt(this.interestRatePurchasing, this.monthPurchasingSliderModel, this.amountPurchasingSliderModel)
      return Math.ceil(unRoundedMonthlyPayment)
    },

    // calculate rate for purchasing service
    interestRatePawn () {
      if (this.interestRatesPawn && this.interestRatesPawn.length > 0) {
        const rate = this.interestRatesPawn
        const tempResult = rate.filter((item) => {
          const satisfiedAmount = this.amountPawnSliderModel >= item.start_amount && this.amountPawnSliderModel <= item.end_amount
          const satifiedMonth = this.monthPawnSliderModel >= item.start && this.monthPawnSliderModel <= item.end
          const defaultMonth = item.start === 0 && item.end === 0
          return satisfiedAmount && (satifiedMonth || defaultMonth)
        })
        if (tempResult.length === 0) {
          const half = (this.pawn.amount.min + this.pawn.amount.max) / 2
          if (this.amountPawnSliderModel > half) {
            return 8
          }
          return 15
        } else if (tempResult.length === 1) {
          return parseFloat(tempResult[0].percentage)
        } else {
          const res = tempResult.filter((item) => {
            return !(item.start === 0 && item.end === 0)
          })[0]
          return parseFloat(res.percentage)
        }
      }
    },
    calculatePawn () {
      const unRoundedMonthlyPayment = this.pmt(this.interestRatePawn, this.monthPawnSliderModel, this.amountPawnSliderModel)
      return Math.ceil(unRoundedMonthlyPayment)
    },

    isLoanPending () {
      return this.$store.state.has_pending_loan
    },
    logged () {
      return this.$store.state.logged_in
    }
  }),

  methods: {
    checkIfIsLogged () {
      const token = localStorage.getItem('token')
      if (token) {
        return true
      } else {
        return false
      }
    },
    openChat () {
      window.FB.CustomerChat.showDialog()
    },
    getBackground () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/background/get-background')
        .then((response) => {
          if (response.data.code === 1 && response.data.data !== null) {
            this.backgroundImage = response.data.data.image
          }
        })
    },
    checkRoute () {
      if (this.$route.name === 'home') {
        this.showForm = 'payday_loan'
      } else if (this.$route.name === 'personal_loans') {
        this.showForm = 'personal_loan'
      } else if (this.$route.name === 'purchasing_service') {
        this.showForm = 'purchasing'
      } else if (this.$route.name === 'pawn_service') {
        this.showForm = 'pawn'
      }
    },
    setData () {
      this.validations = null
      this.messageError = null
      this.data.amountBorrow = 0
      this.data.amountDate = 0

      if (this.showForm === 'payday_loan') {
        this.data.loanType = 'Payday'
        this.data.amountBorrow = this.$refs.payday.currentAmount
        this.data.amountDate = this.$refs.payday.currentDuration
      } else if (this.showForm === 'personal_loan') {
        this.data.loanType = 'Personal'
        this.data.amountBorrow = this.amountPersonalSliderModel
        this.data.amountDate = this.monthSliderModel
      } else if (this.showForm === 'purchasing') {
        this.data.loanType = 'Purchasing'
        this.data.amountBorrow = this.amountPurchasingSliderModel
        this.data.amountDate = this.monthPurchasingSliderModel
      } else if (this.showForm === 'pawn') {
        this.data.loanType = 'Pawn'
        this.data.amountBorrow = this.amountPawnSliderModel
        this.data.amountDate = this.monthPawnSliderModel
      }
    },
    requestNewLoan () {
      this.setData()
      sessionStorage.setItem('typeOfLoan', this.data.loanType)
      this.$router.push({ name: 'new-loan' })
    },
    applyNow () {
      this.setData()
      let phone = null
      const data = {
        name: this.data.name,
        email: this.data.email,
        last_name: this.data.last_name
      }
      if (this.data.phone) {
        phone = this.data.phone
        data.phone = '855' + phone.replace(/\s+/g, '').substring(1)
      }
      if (this.data.loanType === 'Personal' || this.data.loanType === 'Payday') {
        this.$router.push({ name: 'borrow-form', params: { formType: 'borrow' } })
      } else if (this.data.loanType === 'Purchasing') {
        this.$router.push({ name: 'purchasing-form', params: { formType: 'borrow' } })
      } else if (this.data.loanType === 'Pawn') {
        this.$router.push({ name: 'pawn-form', params: { formType: 'borrow' } })
      }
    },
    onResizeScreen () {
      this.formHeight = this.$refs.payDayForm.clientHeight
    },
    onClickBorrowInvest (item) {
      if (this.borrowInvestModel === item) {
        this.borrowInvestModel = 'none'
      } else {
        this.borrowInvestModel = item
      }
    },

    getInterestRatePaydayLoan () {
      this.$axios.post(this.baseUrl + '/api/v1/interest-rate/get-interest-rates')
        .then((response) => {
          if (response.data.code === 1 && response.data.data !== null) {
            const result = response.data.data
            if (result.min_amount) {
              this.paydayLoan.amount.min = result.min_amount
              this.amountSliderModel = result.min_amount
            }
            if (result.max_amount) {
              this.paydayLoan.amount.max = result.max_amount
            }
            if (result.rates.length > 0) {
              this.interestRates = result.rates
            }
          }
        })
    },

    getInterestRatePersonalLoan () {
      this.$axios.post(this.baseUrl + '/api/v1/interest-rate/personal-loan/get-interest-rates')
        .then((response) => {
          if (response.data.code === 1 && response.data.data !== null) {
            const result = response.data.data
            if (result.min_amount) {
              this.personalLoan.amount.min = result.min_amount
              this.amountPersonalSliderModel = result.min_amount
            }
            if (result.max_amount) {
              this.personalLoan.amount.max = result.max_amount
            }
            if (result.min) {
              this.personalLoan.duration.min = result.min
              this.monthSliderModel = result.min
            }
            if (result.max) {
              this.personalLoan.duration.max = result.max
            }
            if (result.rates.length > 0) {
              this.interestRatesPersonalLoan = result.rates
            }
          } else {
            this.interestRatesPersonalLoan = null
          }
        })
    },

    getInterestPurchasing () {
      this.$axios.post(this.baseUrl + '/api/v1/interest-rate/purchasing/get-interest-rates')
        .then((response) => {
          if (response.data.code === 200 && response.data.data !== null) {
            const result = response.data.data
            if (result.min_amount) {
              this.purchasing.amount.min = result.min_amount
              this.amountPurchasingSliderModel = result.min_amount
            }
            if (result.max_amount) {
              this.purchasing.amount.max = result.max_amount
            }
            if (result.min) {
              this.purchasing.duration.min = result.min
              this.monthPurchasingSliderModel = result.min
            }
            if (result.max) {
              this.purchasing.duration.max = result.max
            }
            if (result.rates.length > 0) {
              this.interestRatesPurchasing = result.rates
            }
          }
        })
    },

    getInterestPawn () {
      this.$axios.post(this.baseUrl + '/api/v1/interest-rate/pawn/get-interest-rates')
        .then((response) => {
          if (response.data.code === 1 && response.data.data !== null) {
            const result = response.data.data
            if (result.min_amount) {
              this.pawn.amount.min = result.min_amount
              this.amountPawnSliderModel = result.min_amount
            }
            if (result.max_amount) {
              this.pawn.amount.max = result.max_amount
            }
            if (result.min) {
              this.pawn.duration.min = result.min
              this.monthPawnSliderModel = result.min
            }
            if (result.max) {
              this.pawn.duration.max = result.max
            }
            if (result.rates.length > 0) {
              this.interestRatesPawn = result.rates
            }
          }
        })
    },

    pmt (rate, number_periods, present_value, future_value, type) {
      /**
       * !!!!!!!!!!!!!!!!!!!!!! DO NOT DELETE THIS COMMENT !!!!!!!!!!!!!!!!!!!!!
       * ----------------------------------------------------------------------
       * rate   - interest rate per month
       * number_periods   - number of periods (months)
       * present_value   - present value
       * future_value   - future value
       * type - when the payments are due:
       *   0: end of the period, e.g. end of month (default)
       *   1: beginning of period
       */

      if (!future_value) future_value = 0
      if (!type) type = 0
      if (!rate && rate > 100) rate = 0
      if (rate === 0) return parseFloat((present_value + future_value) / number_periods).toFixed(2)

      const insterest_rate = rate / 100
      const pvif = Math.pow(1 + insterest_rate, number_periods)
      let pmt = insterest_rate / (pvif - 1) * -(present_value * pvif + future_value)
      if (type === 1) {
        pmt /= (1 + insterest_rate)
      }
      return -parseFloat(pmt).toFixed(2)
    },

    checkUserHasLoadpanding () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/borrow/check-account-has-loan-pending')
        .then((response) => {
          if (response.data.code === 1) {
            this.has_pending_loan = response.data.data.has_pending_loan
            this.$store.dispatch('checkUserHasPendingLoan', this.has_pending_loan)
          }
        })
    }
  },
  mounted () {
    this.getBackground()
    this.$nextTick(function () {
      this.formHeight = this.$refs.payDayForm.clientHeight
      this.getInterestRatePaydayLoan()
      this.getInterestRatePersonalLoan()
      this.getInterestPurchasing()
      this.getInterestPawn()
      if (localStorage.getItem('token')) {
        this.checkUserHasLoadpanding()
      }
    })
    this.checkRoute()
    window.addEventListener('resize', this.onResizeScreen)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResizeScreen)
  }
}
</script>

<style scoped>
@import "../assets/styles/scroller.css";
@import "../assets/styles/hasBackground.css";

.masthead {
  padding-top: 122px !important;
  padding-bottom: 122px !important;
  color: black !important;
  background-size: cover;
  height: auto;
  min-height: auto;
  background-color: #5a5a5a;
  background-blend-mode: overlay;
  display: flex;
  background-position: top;
}

.bg-img {
  width: 100%;
}

.form-input-header {
  padding: 10px 30px;
}

.service-avatar {
  background-image: url("../../public/img/woman-call.png");
  border-radius: 50%;
  background-position: top;
  background-size: cover;
  height: 100px;
  width: 100px;
  display: inline-block;
}

.cash-hero-quote {
  color: var(--dark-blue);
  font-size: var(--title-font-size) !important;
  display: block;
}

.form-input-error {
  border: 1px solid var(--danger) !important;
}

.form-input-mb {
  margin-bottom: 15px;
}

.form-input-error::placeholder {
  color: var(--danger) !important;
}

.choice {
  font-size: 1.2em;
  font-family: var(--primary-font) !important;
  color: black;
}

.choice > div {
  display: inline-block;
  padding: 8px 25px;
  position: relative;
}

.choice:hover > div {
  cursor: pointer;
}

.payment-container {
  margin-top: 20px;
}

.display-amount-container {
  margin: 15px 0;
}

.payment-amount {
  font-weight: bold;
  font-size: 1.5em;
}

.service-avatar-container {
  margin-top: 30px;
}

.text-white {
  color: white !important;
}

.invest-description {
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: 300;
}

.choice > div:after {
  content: '';
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border: 3px solid var(--primary);
  transform: scale(0);
  position: absolute;
  transition: 200ms;
}

.choice > div {
  transition: 500ms;
}

.choice.active-tab > div {
  color: var(--primary);
  background-color: white;
}

.choice > div:hover:after, .choice.active-tab > div:after {
  transform: scale(1);
}

.choice:not(.active-tab) > div:hover:after {
  border-color: black;
}

.warning-container {
  text-align: center;
}

.warning-container > div {
  margin-top: 10px;
  padding: 5px 15px;
  border-radius: 20px;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  font-weight: lighter;
  color: white;
  background-color: var(--dark-yellow);
  transition: 200ms;
  opacity: 0;
}

.warning-container > div.show {
  opacity: 1;
}

/*=====================================================*/
.block-btn-borrow,
.block-btn-invest {
  width: 50%;
}

.block-btn-borrow {
  padding: 0 7px 0 15px;
}

.block-btn-invest {
  padding: 0 15px 0 7px;
}

.btn-borrow-invest {
  background-color: #ffffff;
  color: black;
  padding: 12px 0;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  border: 3px solid var(--secondary);
  border-radius: 8px;
}

.black {
  color: black !important;
}

.btn-active {
  color: white !important;
  background-color: var(--primary) !important;
  border: 3px solid var(--primary);
}

.borrow-invest-item {
  position: relative;
}

.borrow-invest-item > div.active {
  display: block;
  border-bottom: 0;
}

a {
  color: white !important;
  display: block;
}

a:hover {
  text-decoration: none !important;
}

a.link-condition {
  /*color: var(--primary) !important; Open after 5days*/
  color: var(--dark-blue) !important;
  display: inline;
}

a.link-condition:hover {
  text-decoration: underline !important;
}

.sub-nav-content {
  width: 100%;
  text-align: left;
}

.sub-navbar-content {
  background: var(--primary);
  padding: 15px;
  margin: 0;
  /*border-radius: 5px;*/
  box-shadow: 1px 8px 35px #00000044;
  height: auto;
  z-index: 104;
}

.sub-nav-panel {
  position: relative;
  font-size: 1rem;
  color: white;
}

.sub-nav-item {
  width: 100%;
}

.sub-nav-item {
  padding: 10px 0 10px 20px;
}

.sub-nav-item::after:last-child {
  border: none;
}

.sub-nav-penal-item {
  padding-right: 10px;
}

.has-border-b {
  border-bottom: 1px solid #cac7c7;
}

.sub-nav-panel-title {
  font-size: 1.0625rem;
}

.nav-chevron-right {
  margin: 0 5px;
  font-size: 13px;
}

.sub-nav-item:hover {
  cursor: pointer;
}

.sub-nav-item:hover .sub-nav-panel-title,
.sub-nav-item:hover .nav-chevron-right {
  color: var(--secondary) !important;
}

.sub-nav-panel-desc {
  display: block;
  padding-top: 10px;
  font-weight: lighter;
}

.chat-label {
  margin-top: 10px;
}

.chat-label:hover {
  color: var(--primary);
  cursor: pointer;
}

.img-chat {
  width: 35px;
  margin-right: 10px;
}

/*------------------------------------------------*/
@media screen and (max-width: 991px) {
  .masthead {
    padding-top: 140px !important;
  }

  .label-title-loan {
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .masthead {
    padding-top: 40px !important;
  }

  .service-avatar-container {
    margin-top: 30px;
  }
}

@media screen and (max-width: 576px) {
  .masthead {
    padding-top: 92px !important;
    padding-bottom: 0 !important;
  }
}
</style>
